export function EmoviDocDisclaimer() {
  return (
    <div className="flex-shrink-0 px-4 py-3 border-t border-border bg-muted/20 text-[10px] text-muted-foreground leading-relaxed">
      EmoviDoc è uno strumento di supporto al ragionamento clinico. Non sostituisce il giudizio
      professionale dello psicologo.
    </div>
  );
}
